import {IRegion} from "app/shared/model/region.model";
import {IMmamaEntityMaster} from "app/shared/model/mmama-entity-master.model";

export interface IMmamaEntityDetail {
  id?: string;
  enDescription?: string;
  stDescription?: string;
  countryId?: string;
  country?: IRegion;
  isActive?: boolean;
  displayOrder?: number;
  required?: boolean;
  entityMasterId?: number;
  entityMaster?: IMmamaEntityMaster
}

export const defaultValue: Readonly<IMmamaEntityDetail> = {};
